<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,782.5l8,2c0,3.77-0.01,6.47-0.33,8.61l-1.83-1.83c0.1-0.23,0.16-0.5,0.16-0.78l0,0c0-1.11-0.9-2-2-2l0,0
	c-1.1,0-2,0.89-2,2l0,0l0,0c0,1.1,0.9,2,2,2l0,0c0.28,0,0.55-0.06,0.8-0.17l-0.01,0.01l2.52,2.52c-0.47,1.6-1.25,2.87-2.55,4.13
	v-3.81l-4-4v-2.83c0.74-0.3,1.25-1.02,1.25-1.85l0,0l0,0c0-1.11-0.9-2-2-2l0,0c-1.1,0-2,0.89-2,2l0,0l0,0
	c0,0.83,0.51,1.55,1.24,1.85l0.01,0.01v3.46l4,3.99v4.47c-0.91,0.7-1.97,1.42-3.25,2.23c-4.75-2.97-6.67-4.89-7.46-8.25h3.15
	l2.47,2.47c-0.1,0.23-0.16,0.5-0.16,0.78v0c0,1.1,0.9,2,2,2l0,0c1.1,0,2-0.9,2-2l0,0l0,0c0-1.11-0.9-2-2-2l0,0
	c-0.28,0-0.55,0.06-0.79,0.16l0.01,0l-2.47-2.47v-0.84c0.74-0.3,1.25-1.02,1.25-1.85l0,0c0-1.11-0.9-2-2-2l0,0
	c-0.83,0-1.54,0.51-1.84,1.23l0,0.01h-2.08c-0.05-1.51-0.07-3.18-0.07-5.25L0.5,782.5z M-5.35,791.25c0.21,0.5,0.6,0.89,1.09,1.1
	l0.01,0.01v0.4h-2.97c-0.06-0.48-0.12-0.96-0.16-1.5H-5.35z"/>
</svg>

</template>